// @flow
import React from 'react';
import { reduxForm } from 'redux-form';

import { colors } from '../../shared/styles';

import StyledForm from '../shared/StyledForm';
import Scrollable from '../shared/Scrollable';
import styled from 'styled-components';
import moment from 'moment';

const StyledTable = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & .row {
        max-width: 100%;
    }

    & table {
        width: 100%;
        max-width: 100%;
        border: solid 1px ${colors.offWhite};
        margin-bottom: 20px;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: left;
    }

    & tbody,
    & tfoot,
    & thead,
    & tr,
    & th,
    & td {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        border-collapse: collapse;
        border-spacing: 0;
        vertical-align: middle;
        text-align: left;
    }

    thead {
        background: #e4e8e9;
        overflow: hidden;
        border-bottom: 1px solid #d9d9db;
    }

    th {
        box-sizing: border-box;
        width: calc((100% - 100px) / 3);
        font-weight: normal;
        padding: 15px 20px;

        &:last-of-type {
            width: 95px;
        }
    }

    tbody {
        tr {
            font-weight: lighter;
            background: #f3f3f5;

            &:nth-of-type(odd) {
                background: ${colors.white};
            }
        }
    }

    td {
        padding: 15px 20px;
        white-space: nowrap;
        vertical-align: middle;
    }
`;

let PropertyActivityLogForm = props => {
    const { activityLogList } = props;

    return (
        <StyledForm>
            <Scrollable additionalClassName="scroll-area">
                <div className="noflex">
                    <div className="col">
                        <h4>Property Edit History</h4>

                        <StyledTable>
                            {activityLogList &&
                                activityLogList.length > 0 &&
                                <table className="contact-list">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Edit Details</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activityLogList.map(
                                            (activityLog, index) => {
                                                const activityLogDate = moment(
                                                    activityLog.propertyUpdateLogCreatedAt
                                                ).format(
                                                    'DD/MM/YYYY [at] h:mma'
                                                );

                                                const activityLogUser =
                                                    activityLog.propertyUpdateLogType ===
                                                    'property.update.status.automatically'
                                                        ? 'Automated User'
                                                        : activityLog.user
                                                          ? activityLog.user
                                                                .userForenames +
                                                            ' ' +
                                                            activityLog.user
                                                                .userSurname
                                                          : '';
                                                let activityLogType = '';
                                                if (
                                                    activityLog.propertyUpdateLogType ===
                                                        'property.update.status.automatically' &&
                                                    activityLog
                                                        .propertyUpdateLogMetaData[
                                                        'property.status'
                                                    ] != null
                                                ) {
                                                    activityLogType =
                                                        'Property Staus updated : ' +
                                                        activityLog
                                                            .propertyUpdateLogMetaData[
                                                            'property.status'
                                                        ][
                                                            'property.status.old'
                                                        ] +
                                                        ' to ' +
                                                        activityLog
                                                            .propertyUpdateLogMetaData[
                                                            'property.status'
                                                        ][
                                                            'property.status.new'
                                                        ];
                                                } else if (
                                                    activityLog.propertyUpdateLogMetaData &&
                                                    activityLog
                                                        .propertyUpdateLogMetaData[
                                                        'property.status'
                                                    ] != null
                                                ) {
                                                    activityLogType =
                                                        'Property Staus updated : ' +
                                                        activityLog
                                                            .propertyUpdateLogMetaData[
                                                            'property.status'
                                                        ][
                                                            'property.status.old'
                                                        ] +
                                                        ' to ' +
                                                        activityLog
                                                            .propertyUpdateLogMetaData[
                                                            'property.status'
                                                        ][
                                                            'property.status.new'
                                                        ];
                                                } else if (
                                                    activityLog.propertyUpdateLogMetaData &&
                                                    activityLog
                                                        .propertyUpdateLogMetaData[
                                                        'property.status'
                                                    ] != null
                                                ) {
                                                    activityLogType = '';
                                                } else {
                                                    activityLogType =
                                                        'Property Edited';
                                                }

                                                return (
                                                    <tr
                                                        key={`${index}.${activityLog.propertyUpdateLogId}`}
                                                    >
                                                        <td>
                                                            {activityLogUser}
                                                        </td>
                                                        <td>
                                                            {activityLogType}
                                                        </td>
                                                        <td>
                                                            {activityLogDate}
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>}
                        </StyledTable>
                    </div>
                </div>
            </Scrollable>
        </StyledForm>
    );
};

PropertyActivityLogForm = reduxForm({
    form: 'propertyActivityLogs',
})(PropertyActivityLogForm);

export default PropertyActivityLogForm;



// WEBPACK FOOTER //
// ./src/components/PropertyForms/PropertyActivityLogForm.js